/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import withFieldPopulationToggling from './withFieldPopulationToggling.js';
import FieldPopulationToggle from './FieldPopulationToggle.jsx';

export default withFieldPopulationToggling(FieldPopulationToggle);
